/**
 * Kampanya geri sayımı. Sayfadaki [data-pg-cd] öğelerini her saniye data-end (saniye) değerine göre günceller.
 * data-within: kalan süre bundan fazlaysa sayaç gösterilmez (yoksa her zaman gösterilir).
 * data-keep: pencere dışındayken öğe gizlenmez, sunucunun bastığı metin kalır.
 * data-remove: süre dolunca sayaçla birlikte gizlenecek en yakın üst öğenin seçicisi.
 * Sayfa önbellekten gelse bile karar tarayıcı saatiyle verilir; süre dolmuşsa sayaç hiç görünmez.
 */
(() => {
  if (window.__pgCountdown) return;
  window.__pgCountdown = true;

  const pad = (n) => String(n).padStart(2, '0');

  const paint = (el, left) => {
    const d = Math.floor(left / 86400);
    const h = Math.floor((left % 86400) / 3600);
    const m = Math.floor((left % 3600) / 60);
    const s = left % 60;
    const set = (sel, value) => {
      const node = el.querySelector(sel);
      if (node && node.textContent !== value) node.textContent = value;
    };
    set('[data-pg-cd-d]', String(d));
    set('[data-pg-cd-h]', pad(h));
    set('[data-pg-cd-m]', pad(m));
    set('[data-pg-cd-s]', pad(s));
    const text = el.matches('[data-pg-cd-text]') ? el : el.querySelector('[data-pg-cd-text]');
    if (text) text.textContent = `${d > 0 ? `${d} gün ` : ''}${pad(h)}:${pad(m)}:${pad(s)}`;
  };

  const expire = (el) => {
    el.hidden = true;
    el.removeAttribute('data-pg-cd');
    const box = el.dataset.remove ? el.closest(el.dataset.remove) : null;
    if (!box) return;
    const wasActive = box.classList.contains('is-active');
    box.hidden = true;
    box.style.display = 'none';
    box.classList.remove('is-active');
    if (wasActive) {
      const scope = box.closest('[data-smart-header]') || document;
      const next = scope.querySelector('[data-smart-header-announcement-next]');
      if (next) next.click();
    }
  };

  const tick = () => {
    const now = Math.floor(Date.now() / 1000);
    document.querySelectorAll('[data-pg-cd]').forEach((el) => {
      const left = Number(el.dataset.end) - now;
      if (!(left > 0)) {
        expire(el);
        return;
      }
      const within = Number(el.dataset.within) || 0;
      if (within && left > within) {
        if (!('keep' in el.dataset)) el.hidden = true;
        return;
      }
      el.hidden = false;
      paint(el, left);
    });
  };

  tick();
  setInterval(tick, 1000);
})();
